import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { ReactComponent as Pin } from '../../assets/pin.svg';
import { ReactComponent as PeoplePin } from '../../assets/peoplePin.svg';
import { ReactComponent as LikePin } from '../../assets/likePin.svg';
import { ReactComponent as PeopleLikePin } from '../../assets/peopleLikePin.svg';
const PeoplePinComponent = styled(PeoplePin) `
  position: absolute;
  width: ${props => props.width};
  height: ${props => props.height};
  transform: translate(-50%, -80%);
  fill: ${props => props.fill}
`;
const PinStyle = styled(Pin) `
  position: absolute;
  width: ${props => props.width};
  height: ${props => props.height};
  transform: translate(-50%, -80%);
  fill: ${props => props.fill}
`;
const LikePinStyle = styled(LikePin) `
  position: absolute;
  width: ${props => props.width};
  height: ${props => props.height};
  transform: translate(-50%, -80%);
  fill: ${props => props.fill}
`;
const PeopleLikePinStyle = styled(PeopleLikePin) `
  position: absolute;
  width: ${props => props.width};
  height: ${props => props.height};
  transform: translate(-50%, -80%);
  fill: ${props => props.fill}
`;
const GeneratePin = ({ id, icons, fillColor, width = '50px', height = '50px' }) => {
    return (icons === null || icons === void 0 ? void 0 : icons.people) && icons.like
        ? _jsx(PeopleLikePinStyle, { fill: fillColor, width: width, height: height, className: id })
        : (icons === null || icons === void 0 ? void 0 : icons.like)
            ? _jsx(LikePinStyle, { fill: fillColor, width: width, height: height, className: id })
            : (icons === null || icons === void 0 ? void 0 : icons.people)
                ? _jsx(PeoplePinComponent, { fill: fillColor, width: width, height: height, className: id })
                : _jsx(PinStyle, { fill: fillColor, width: width, height: height, className: id });
};
export default GeneratePin;
